import type { HTMLAttributes } from "react";
import { useMenu } from "../menuContext";
import {
  subitemContainerActiveClass,
  subitemContainerClass,
} from "../styles.css";
import type { MenuItemProps } from "../types";

interface MenuSubitemComponentProps extends HTMLAttributes<HTMLAnchorElement> {
  subitem: MenuItemProps;
  parentPath?: string;
  setSearch?: (value: string) => void;
}

export const MenuSubitem = ({
  subitem,
  parentPath = "",
  setSearch,
  ...props
}: MenuSubitemComponentProps) => {
  const SubitemComponent = useMenu();
  const pathToGo = subitem.function ? "#" : parentPath + subitem.path || "#";
  const isActive = pathToGo === window.location.pathname;

  const componentProps = {
    to: pathToGo,
    href: pathToGo,
    id: `menu-item-${subitem.path}`,
    className: `${subitemContainerClass} ${
      isActive ? subitemContainerActiveClass : ""
    }`,
    onClick: () => {
      setSearch?.("");
      subitem.function?.();
    },
    ...props,
  };

  return (
    <SubitemComponent {...componentProps}>
      <span>{subitem.searchText || subitem.text}</span>
    </SubitemComponent>
  );
};
